module.exports = __webpack_public_path__ + "static/media/in_app_notifications.86795680.png";